export default __webpack_public_path__ + "static/media/logoError.6c3e128d.png";